// extracted by mini-css-extract-plugin
export default {"className":"ButtonBorderWrapper_className__9Hfuf"};